import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import * as actions from "./_redux/Action";
import { useSubheader } from "../../../../_metronic/layout";
import CKEditor from "react-ckeditor-component";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import {
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar,
  DatePickerField,
  CustomeSelect,
  Input2,
} from "../../../../_metronic/_partials/controls";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import DropdownReactSelect from "../../../components/DropdownReactSelect";
import Upload from "../../../components/upload/Upload";
import helperFunc from "../../../../_metronic/_helpers/helperFunc";
import SearchSelectInput from "../../../components/SelectComponents/SearchSelectInput";
import moment from "moment";
import "../../../../_metronic/_assets/sass/customstyle.react.scss";

const AdscompanyView = (props) => {
  const suhbeader = useSubheader();
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [file, setFile] = useState({
    default: "",
  });
  const [count, setCount] = useState(0);
  const { id } = useParams();
  const [
    countrySelectedDropdownFilterData,
    setCountryListDropdownFilterData,
  ] = useState();
  const [countryDropdownFilterData, setCountryDropdownFilterData] = useState(
    []
  );

  const [currencyDropdownFilterData, setCurrencyDropdownFilterData] = useState(
    []
  );
  const [
    currencySelectedDropdownFilterData,
    setCurrencySelectedDropdownFilterData,
  ] = useState();
  const [handleBName, sethandleBName] = useState();
  const [handleadstitle1, sethandleadstitle1] = useState();
  const [handleadstitle2, sethandleadstitle2] = useState();

  const [handleAdsLink, sethandleAdsLink] = useState();
  const [handledealtype, sethandledealtype] = useState();
  const [handleearningamount, sethandleearningamount] = useState();
  const [endDateEnable, setEndDateEnable] = useState(true);

  const [endDate, setEndDate] = useState(undefined);
  const [handleperdaycapping, sethandleperdaycapping] = useState();
  const [handlePhone, sethandlePhone] = useState();
  const [startDateEnable, setStartDateEnable] = useState(true);
  const [startDate, setStartDate] = useState(undefined);
  const [handleCompanyperson, sethandleCompanyperson] = useState();
  const [handlepaymentcycle, sethandlepaymentcycle] = useState();
  const [CheckedActive, setCheckedActive] = useState();
  const [cols, setCols] = useState();
  const [handleAmount, sethandleAmount] = useState();
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");

  let history = useHistory();
  const [companyDropdownFilterData, setCompanyDropdownFilterData] = useState(
    []
  );

  const [
    companySelectedDropdownFilterData,
    setCompanySelectedDropdownFilterData,
  ] = useState(null);

  const [stepsOfRedeem, setStepsOfRedeem] = useState([
    {
      value: "",
    },
  ]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state.newAdscompanylistSlice }),
    shallowEqual
  );
  const [frmInitialValues, setFrmInitialValues] = useState({
    country: [],
    platform: [],
    company: "",
    brandName: "",
    brandImage: {},
    adLink: "",
    title: "",
    description: "handleadstitle2",
    howToEarn: "",
    dealType: "",
    perDayCapping: 0,
    earningCurrency: [],
    earningAmmount: 0,
    adStartDate: "",
    adEndDate: "",
    isActive: "",
  });
  // useEffect(() => {
  //   setTimeout(() => {
  //     dispatch(actions.fetchSingle(id));
  //   }, 1000);
  // }, [dispatch, id]);
  const {
    actionsLoading,
    countryDropdownList,
    company,
    currency,
    coinStoresForEdit,
  } = currentState;
  const platform = [
    // { _id: 'all', name: 'All' },
    { _id: "mobile", name: "Mobile" },
    { _id: "webportal", name: "WebPortal" },
    // { _id: 'playstore', name: 'PLAYSTORE' },
    // { _id: 'appStore', name: 'APPSTORE' },
    // { _id: 'apkPlaystore', name: 'APK - PLAYSTORE' },
    // { _id: 'apkIos', name: 'APK - IOS' },
    // { _id: 'playstoreIos', name: 'PLAYSTORE - IOS' },
  ];
  const [selectedPlatforms, setSelectedPlatforms] = useState([]);

  const handlePlatformChange = (e) => {
    const value = e.target.value;
    if (selectedPlatforms.includes(value)) {
      setSelectedPlatforms(
        selectedPlatforms.filter((platform) => platform !== value)
      );
    } else {
      setSelectedPlatforms([...selectedPlatforms, value]);
    }
  };
  useEffect(() => {
    dispatch(actions.fetchCountriesDropdownList());
  }, [dispatch]);

  useEffect(() => {
    if (countryDropdownList && countryDropdownList.data) {
      let temp = [];
      countryDropdownList.data.forEach((element, i) => {
        temp.push({
          _id: i + 1,
          label: element.name,
          value: element._id,
        });
      });

      setCountryDropdownFilterData(temp);
    }
  }, [countryDropdownList]);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const userCompany = userData?.company || [];
    let temp = [];
    setCols(temp);
    dispatch(actions.fetchCompanyList());
  }, []);

  useEffect(() => {
    let tempb = [];
    const userdata = JSON.parse(localStorage.getItem("userData"));
    const userCompany = userdata?.company || [];

    for (let i = 0; i < company.length; i++) {
      if (helperFunc.isAdmin() && !helperFunc.isAdmin()) {
        if (userCompany.includes(company[i]._id)) {
          let obj = {};
          obj.label = company[i].name;
          obj.value = company[i]._id;
          tempb.push(obj);
        }
      } else {
        let obj = {};
        obj.label = company[i].name;
        obj.value = company[i]._id;
        tempb.push(obj);
      }
    }

    setCompanyDropdownFilterData(tempb);
  }, [company]);

  //   currency
  //currency
  useEffect(() => {
    dispatch(actions.fetchCurrencyList());
  }, [dispatch]);

  useEffect(() => {
    let tempb = [];
    const userdata = JSON.parse(localStorage.getItem("userData"));
    const userCurrency = userdata?.currency || [];

    for (let i = 0; i < currency.length; i++) {
      if (helperFunc.isAdmin() && !helperFunc.isAdmin()) {
        if (userCurrency.includes(currency[i]._id)) {
          let obj = {};
          obj.label = currency[i].name;
          obj.value = currency[i]._id;
          tempb.push(obj);
        }
      } else {
        let obj = {};
        obj.label = currency[i].name;
        obj.value = currency[i]._id;
        tempb.push(obj);
      }
    }
    setCurrencyDropdownFilterData(tempb);
  }, [currency]);
  const [getId, setID] = useState();
  const [getIdfromURL, setIDfromURL] = useState();
  var baseUrl = window.location.href;
  var parts = baseUrl.split("/");
  var idfromurl = parts[parts.length - 1];

  const [getDatafromAPI, setDatafromAPI] = useState();
  const [getIDforCompany, setIDforCompany] = useState();
  // Fetch the id when the component mounts

  const countriesArray = Array.isArray(
    countrySelectedDropdownFilterData,
    companySelectedDropdownFilterData
  )
    ? countrySelectedDropdownFilterData?.map((country) => country.value)
    : companySelectedDropdownFilterData?.map((country) => country.value);

  // currencyyy

  const myData = {
    country: countriesArray,
    company: getIDforCompany || coinStoresForEdit?.data[0]?.param?._id,
    brandName: handleBName,
    brandImage: file,
    adLink: handleAdsLink,
    title: handleadstitle1,
    description: handleadstitle2,
    platform: selectedPlatforms,
    howToEarn: stepsOfRedeem.map((step) => step.value),
    dealType: handledealtype,
    perDayCapping: parseInt(handleperdaycapping),
    earningCurrency: currencySelectedDropdownFilterData?.value,
    earningAmmount: parseInt(handleearningamount),
    adStartDate: startDate,
    adEndDate: endDate,
    isActive: CheckedActive,
    _id: getIdfromURL || idfromurl,
  };
  const url = window.location.search;

  console.log("gdgkjdfngjkfngfdjgfd", idfromurl);

  const backToList = () => {
    history.push(
      `/DownloadAdscompanylist/Companydetailpage/${getIDforCompany}`
    );
    window.location.reload();
  };

  const backToList1 = () => {
    history.push(`/DownloadAdscompanylist/Companydetailpage/${idfromurl}`);
    window.location.reload();
  };
  // localStorage.setItem(
  //   "currencyData",
  //   coinStoresForEdit?.data[0]?.param?.adsEarningCurrency
  // );
  useEffect(() => {
    if (id) {
      setTimeout(() => {
        dispatch(actions.fetchSingle(id))
          .then((coinStoresForEdit) => {
            setIDforCompany(coinStoresForEdit?.data?.[0].param?.companyID);
            sethandleBName(coinStoresForEdit?.data?.[0].param.brandName);
            sethandleAdsLink(coinStoresForEdit?.data[0]?.param.link);
            sethandleadstitle1(coinStoresForEdit?.data[0]?.param.title);
            setSelectedPlatforms(coinStoresForEdit?.data[0]?.param.platform);
            // setCompanySelectedDropdownFilterData(
            //   coinStoresForEdit?.data[0]?.param.countries.name
            // );
            console.log(
              "fdfdgfdgdgdfgd",
              coinStoresForEdit?.data[0]?.param?.adsEarningCurrency?._id
            );
            if (coinStoresForEdit?.data[0]?.param?.countries?.length > 0) {
              // Map the array of countries to an array of objects with label and value properties
              const selectedCountries = coinStoresForEdit.data[0].param.countries.map(
                (company) => ({
                  label: company.name,
                  value: company._id,
                })
              );

              // Set the selected countries in the state
              setCompanySelectedDropdownFilterData(selectedCountries);
            }
            // earning currency
            if (
              coinStoresForEdit?.data[0]?.param?.earningCurrency?.length > 0
            ) {
              const selectedCurrency = coinStoresForEdit?.data[0]?.param?.earningCurrency.map(
                (currency) => ({
                  label: currency.name,
                  value: currency._id,
                })
              );

              // Set the selected countries in the state
              setCurrencySelectedDropdownFilterData(selectedCurrency);
            } else {
              setCurrencySelectedDropdownFilterData({
                label:
                  coinStoresForEdit?.data[0]?.param?.adsEarningCurrency.name,
                value:
                  coinStoresForEdit?.data[0]?.param?.adsEarningCurrency._id,
              });
            }

            sethandleadstitle2(coinStoresForEdit?.data[0]?.param.description);
            sethandledealtype(coinStoresForEdit?.data[0]?.param.dealType);
            setStartDate(coinStoresForEdit?.data[0]?.param.adStartDate);
            sethandleearningamount(
              coinStoresForEdit?.data[0]?.param.earningAmmount
            );
            sethandleperdaycapping(
              coinStoresForEdit?.data[0]?.param.perDayCapping
            );
            setEndDate(coinStoresForEdit?.data[0]?.param.adEndDate);
            setCheckedActive(coinStoresForEdit?.data[0]?.param.isActive);
            setFile({
              default: coinStoresForEdit?.data[0]?.param.brandImage.default,
            });
            setUploadedImageUrl(
              process.env.REACT_APP_UPLOADED_FILE_URL +
                "/" +
                coinStoresForEdit?.data[0]?.param.brandImage.default
            );
            const howToEarnArray = coinStoresForEdit?.data[0]?.param
              .howToEarn || [""];
            const steps = howToEarnArray.map((value) => ({ value }));

            setStepsOfRedeem(steps);
            setIDfromURL(coinStoresForEdit?.data?.[0].param._id);
            setID(coinStoresForEdit?.item?._id);
            setDatafromAPI(coinStoresForEdit?.data?.[0].param);
          })
          .catch((error) => {
            console.error(error);
          });
      }, 1000);
    }
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? "" : "Add Ads";
    if (coinStoresForEdit && id) {
      _title = `Edit Ads '${coinStoresForEdit &&
        coinStoresForEdit?.data[0]?.param.companyName}'`;
      const item = coinStoresForEdit;

      const data = { ...frmInitialValues, ...item };

      // sethandleBName(coinStoresForEdit?.data?.[0].param.BrandName);

      setFrmInitialValues(data);
    } else {
      setFile(undefined);
    }
    setTitle(_title);
    suhbeader.setTitle(_title);
  }, []);

  const handleChange = (e, i) => {
    e.preventDefault();
    let value = e.target.value;

    setStepsOfRedeem(
      stepsOfRedeem.map((item, i1) => {
        if (i1 === i) {
          return {
            ...item,
            [e.target.name]: value,
          };
        } else {
          return item;
        }
      })
    );
  };
  const addInput = () => {
    setStepsOfRedeem((t) => {
      return [
        ...t,
        {
          value: "",
        },
      ];
    });
  };
  const [getAPIcallStatus, setAPIcallStatus] = useState();
  const saveCoin = (values) => {
    const requiredFields = [
      { field: handleBName, message: "Please select Brand Name" },
      {
        field: companySelectedDropdownFilterData,
        message: "Please select Country",
      },
      { field: file, message: "Please select Brand Image" },
      { field: handleAdsLink, message: "Please select Ads Link" },
      { field: handleadstitle1, message: "Please select Title 1" },
      { field: handleadstitle2, message: "Please select Title 2" },
      { field: handledealtype, message: "Please select Deal Type" },
      { field: handleperdaycapping, message: "Please select Per day capping" },
      {
        field: currencySelectedDropdownFilterData,
        message: "Please select Earning currency",
      },
      { field: handleearningamount, message: "Please select Earning amount" },
      { field: startDate, message: "Please select Start Date" },
      { field: endDate, message: "Please select End Date" },
      {
        field: stepsOfRedeem.some((step) => step.value.trim() !== ""),
        message: "Please select 'How to Earn'",
      },
    ];
    const emptyFields = requiredFields.filter((item) => !item.field);

    if (emptyFields.length > 0) {
      emptyFields.forEach((item) => {
        NotificationManager.error(item.message);
      });
      return;
    }

    if (!id) {
      dispatch(actions.createItem(myData)).then((success) => {
        if (success) {
          // setTimeout(() => {
            NotificationManager.success("Data saved successfully!");
            backToList1(); // Call backToList1() function after successful creation
          // }, 1000);
        } else {
          NotificationManager.error("Failed to save data");
          setAPIcallStatus(false);
        }
      });
    } else {
      dispatch(actions.fetchSingle(id)).then((coinStoresForEdit) => {
        setIDfromURL(id);
        setID(coinStoresForEdit?.item?._id);
        sethandleBName(coinStoresForEdit?.data?.[0].param.brandName);

        // Update the myData object with the edited values and id
        const updatedData = { ...myData, brandImage: file };

        // const updatedData = { ...myData, ...values, id };
        dispatch(actions.updateItem(id, updatedData))
          .then((success) => {
            if (success) {
              setTimeout(() => {
                NotificationManager.success("Data saved successfully!");
                backToList(); // Call backToList1() function after successful creation
              }, 1000);
            } else {
              NotificationManager.error("Failed to save data");
              setAPIcallStatus(false);
            }
          })
          .catch((error) => {
            console.error(error);
            NotificationManager.error("An error occurred while updating data");
            setAPIcallStatus(false);
          });
      });
    }
  };

  const onDateSet = (value, pData) => {
    if (pData && pData.type === "start") {
      setStartDate(value);
    }
    if (pData && pData.type === "end") {
      setEndDate(value);
    }
  };
  const removeTechInput = (index) => {
    const temp = [...stepsOfRedeem];
    temp.splice(index, 1);
    setStepsOfRedeem(temp);
  };
  const handleadstitle1Change = (e) => {
    const value = e.target.value;
    // Replace invalid characters with spaces and limit the length to 32 characters
    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "").slice(0, 32);
    sethandleadstitle1(sanitizedValue);
  };

  const handleadstitle2Change = (e) => {
    const value = e.target.value;
    // Remove invalid characters from the adstitle2 input using a regular expression
    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "").slice(0, 64);
    sethandleadstitle2(sanitizedValue);
  };

  const onUpdateFileValue = (file, fileIndex) => {
    if (fileIndex === 1) {
      setFile(file.image);
    }
  };
  return (
    <Card>
      <NotificationContainer />
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}></CardHeader>
      <CardBody>
        <Formik
          enableReinitialize={true}
          initialValues={{}}
          // validationSchema={LevelsEditSchema}
          onSubmit={(values) => {
            saveCoin(values);
          }}
        >
          {({ handleSubmit, values }) => (
            <Form className="form form-label-right">
              <div className="form-group row">
                {/* {helperFunc.isCountryVisible() && ( */}
                <div className="col-lg-4">
                  <label>Select Country</label>
                  <span style={{ color: "red" }}>*</span>
                  <DropdownReactSelect
                    placeholder="Select Country"
                    name="companies"
                    // value={companySelectedDropdownFilterData}
                    value={
                      companySelectedDropdownFilterData === undefined &&
                      coinStoresForEdit?.company?.name
                        ? {
                            label: coinStoresForEdit.company.name,
                            value: coinStoresForEdit.company._id,
                          }
                        : companySelectedDropdownFilterData
                    }
                    isMulti={true}
                    isClearable={true}
                    isSearchable={true}
                    closeMenuOnSelect={true}
                    options={[
                      ...companyDropdownFilterData, // Existing country options
                    ]}
                    onChange={setCompanySelectedDropdownFilterData}
                  />
                </div>
                {/* )} */}
                <div className="col-lg-4">
                  <Field
                    name="name"
                    component={Input2}
                    placeholder="Brand Name"
                    label="Brand Name"
                    value={handleBName || ""}
                    onChange={(e) => sethandleBName(e.target.value)}
                    isRequired={true}
                  />
                </div>

                {/* email */}
                <div className="col-lg-4">
                  <Field
                    name="adslink"
                    component={Input2}
                    placeholder="Ads Link"
                    label="Ads Link"
                    value={handleAdsLink || ""}
                    onChange={(e) => sethandleAdsLink(e.target.value)}
                    disabled={
                      coinStoresForEdit?.data[0]?.param.link &&
                      coinStoresForEdit?.data[0]?.param.link !== ""
                    }
                    isRequired={true}
                  />
                </div>

                {/* {add title 1} */}
                <div className="col-lg-4 mt-4">
                  <Field
                    name="adstitle1"
                    component={Input2}
                    placeholder="Ads Title 1"
                    label="Ads Title 1"
                    value={handleadstitle1}
                    onChange={handleadstitle1Change}
                    isRequired={true}
                  />
                  {handleadstitle1?.length === 0 && (
                    <span style={{ color: "red" }}>
                      This field is required.
                    </span>
                  )}
                </div>

                {/* ads title 2 */}
                <div className="col-lg-4 mt-4">
                  <Field
                    name="adstitle2"
                    component={Input2}
                    placeholder="Ads Title 2"
                    label="Ads Title 2"
                    value={handleadstitle2}
                    onChange={handleadstitle2Change}
                    isRequired={true}
                  />
                  {handleadstitle2?.length === 0 && (
                    <span style={{ color: "red" }}>
                      This field is required.
                    </span>
                  )}
                </div>

                {/* deal type */}
                <div className="col-lg-2 mt-4">
                  <Field
                    name="dealtype"
                    component={Input2}
                    placeholder="Deal Type"
                    label="Deal Type"
                    value={handledealtype || ""}
                    onChange={(e) => sethandledealtype(e.target.value)}
                    isRequired={true}
                  />
                </div>

                {/* perday camping */}
                <div className="col-lg-2 mt-4">
                  <Field
                    name="perdaycapping"
                    component={Input2}
                    placeholder="Per Day Capping"
                    label="Per Day Capping"
                    value={handleperdaycapping || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[1-9]\d*$/.test(value) || value === "") {
                        sethandleperdaycapping(value);
                      }
                    }}
                    isRequired={true}
                  />
                </div>

                <div className="col mt-4">
                  <label>
                    Currency <span style={{ color: "red" }}>*</span>
                  </label>
                  <DropdownReactSelect
                    placeholder={"Select Currency"}
                    name="currency"
                    value={currencySelectedDropdownFilterData}
                    isMulti={false}
                    isClearable={true}
                    isSearchable={true}
                    closeMenuOnSelect={true}
                    options={currencyDropdownFilterData}
                    onChange={setCurrencySelectedDropdownFilterData}
                  />
                </div>
                {/* earning amount */}
                <div className="col-lg-2 mt-4">
                  <Field
                    name="earningamount"
                    component={Input2}
                    placeholder="Earning Amount"
                    label="Earning Amount"
                    value={handleearningamount || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[1-9]\d*$/.test(value) || value === "") {
                        sethandleearningamount(value);
                      }
                    }}
                    isRequired={true}
                  />
                </div>

                <div className="col-lg-2 mt-4">
                  <DatePickerField
                    label="Ads Start"
                    name="startDate"
                    format="DD-MM-YYYY hh:mm a"
                    minDate={id ? null : moment().format("DD-MM-YYYY hh:mm a")}
                    type="start"
                    date={startDate}
                    onDateSet={(value, pdata) => onDateSet(value, pdata)}
                    isRequired={true}
                  />
                </div>

                {endDateEnable && (
                  <div className="col-lg-2 mt-4">
                    <DatePickerField
                      label="Ads End"
                      name="endDate"
                      format="DD-MM-YYYY hh:mm a"
                      minDate={
                        id ? null : moment().format("DD-MM-YYYY hh:mm a")
                      }
                      type="end"
                      date={endDate}
                      onDateSet={(value, pdata) => onDateSet(value, pdata)}
                      disabled={
                        values?.startDate &&
                        moment(values.startDate).isAfter(moment(values.endDate))
                      }
                      isRequired={true}
                    />
                  </div>
                )}
                <div className="col-lg-4 mt-4">
                  <label className="col-form-label">Platform :</label>
                  <div
                    role="group"
                    aria-labelledby="my-radio-group"
                    className="checkbox-inline"
                  >
                    {platform &&
                      platform.map((item, ind) => (
                        <label className="checkbox" key={"platform" + ind}>
                          <input
                            type="checkbox"
                            name="platform"
                            value={item._id}
                            checked={selectedPlatforms.includes(item._id)}
                            onChange={handlePlatformChange}
                          />
                          <span></span>
                          {item.name}
                        </label>
                      ))}
                  </div>
                </div>
                <div className="col-md-2" style={{ marginTop: "-10px" }}>
                  <label className="col-form-label">Is Active</label>
                  <div className="col-12 w-100 p-0">
                    <span className="switch switch-primary switch-icon">
                      <label>
                        <Field
                          type="checkbox"
                          name="isActive"
                          checked={CheckedActive || ""}
                          onChange={(e) => setCheckedActive(e.target.checked)}
                        />
                        <span></span>
                      </label>
                    </span>
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <div className="col-lg-4 d-flex align-items-center">
                  <div style={{ marginRight: "55px" }}>
                    <Field
                      name="image"
                      component={Upload}
                      label="Image"
                      file={file || uploadedImageUrl}
                      onfileValueSet={(file) => onUpdateFileValue(file, 1)}
                      isRequired={true}
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <label className="col-form-label">
                  How to Earn<span style={{ color: "red" }}>*</span>
                </label>

                {stepsOfRedeem.length > 0 &&
                  stepsOfRedeem.map((val, index) => {
                    return (
                      <div key={"step" + index} className="d-flex mb-10">
                        <input
                          name={`value`}
                          className="form-control"
                          value={val.value}
                          onChange={(e) => handleChange(e, index)}
                        />

                        {index !== 0 && (
                          <button
                            type="button"
                            className="btn btn-danger ml-2"
                            onClick={() => removeTechInput(index)}
                          >
                            <i className="ki ki-minus"></i>
                          </button>
                        )}

                        <button
                          type="button"
                          className="btn btn-dark ml-2"
                          onClick={() => addInput()}
                        >
                          <i className="ki ki-plus"></i>
                        </button>
                      </div>
                    );
                  })}
              </div>
              <div className="form-group justify-content-end row mx-0">
                <button
                  type="button"
                  onClick={id ? backToList : backToList1}
                  className="btn btn-light"
                  disabled={actionsLoading && true}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary ml-2" disabled={actionsLoading && true}>
                  Save
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </CardBody>
    </Card>
  );
};
export default AdscompanyView;
